import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "@patternfly/pfe-markdown/dist/pfe-markdown";
import Env from "./utils/env";

if (Env.getEnvName() === Env.EnvNames.PROD) {
    Sentry.init({
        environment: "production",
        ...(process.env.REACT_APP_SPA_VERSION && {
            release: "spco-001-rhc-certification-workflow@" + process.env.REACT_APP_SPA_VERSION
        }),
        dsn: "https://8ea8c868e00b48aab464b004d3a0d4e6@o59191.ingest.sentry.io/5775440"
    });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
